export const TOP_ROW_DIGIT_CODES = Array.from(
  { length: 10 },
  (_, index) => `Digit${index}`
);

export const NUMPAD_DIGIT_CODES = Array.from(
  { length: 10 },
  (_, index) => `Numpad${index}`
);

export const COMMON_ALLOWED_KEY_CODES = [
  "Backspace",
  "Tab",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Enter",
];

export const MINUS_KEY_CODES = ["Minus", "NumpadSubtract"];

export const isDigitKey = (code: string): boolean =>
  TOP_ROW_DIGIT_CODES.includes(code) || NUMPAD_DIGIT_CODES.includes(code);
